import React, { PropsWithChildren } from 'react';
import { useWindow } from '../../navigation/hooks/useWindow';
import { roundPixel } from '../../utils/math';
import { useStrip } from '../hooks/useStrip';

export const StripWindow: React.FC<PropsWithChildren> = ({ children }) => {
  const { xScale } = useStrip();
  const windowStart = useWindow();

  return (
    <g
      className='strip-window'
      transform={`translate(${-roundPixel(xScale(windowStart))})`}
    >
      {children}
    </g>
  );
};
